module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei7.svg";